import styled from 'styled-components/macro';

const Description = styled.p`
  color: ${({ theme }) => `${theme.colors.gray2}`};
  font-size: ${({ theme }) => `${theme.getValue(12)}px`};
  line-height: 150%;
`;

export default { Description };
